/**
 * Created by Samj on 2017/7/21.
 */
import React from 'react';

//容器控件

const DialogContainer = (Component) => class extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            show: true,
        }
    }
    dismiss() {
        this.setState({
            show: false,
        }, () => {
            this.props.dispose();
        });
    }
    cancel(value) {
        this.setState({
            show: false,
        }, () => {
            this.props.reject(value);
        });
    }
    confirm(value) {
        this.setState({
            show: false,
        }, () => {
            this.props.resolve(value);
        });
    }
    render() {
        return <Component confirm={this.confirm.bind(this)} cancel={this.cancel.bind(this)} dismiss={this.dismiss.bind(this)} show={this.state.show} {...this.props}/>
    }
}

export default DialogContainer;





// WEBPACK FOOTER //
// ./src/components/yunshl/Dialog/DialogContainer.js